import { render, staticRenderFns } from "./ArticleCatalog.vue?vue&type=template&id=93b67dcc"
import script from "./ArticleCatalog.vue?vue&type=script&lang=js"
export * from "./ArticleCatalog.vue?vue&type=script&lang=js"
import style0 from "./ArticleCatalog.vue?vue&type=style&index=0&id=93b67dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports